import styled from 'styled-components'

export const SimpleNavWrapper = styled.div`
  display: flex;
`

export const HorizontalNavContainer = styled.div`
  .Nav_Buttons-Styles {
    background: ${p => p.theme.webMktPalette.button.secondaryWhite};
    color: ${p => p.theme.webMktPalette.text.primaryBlack};
    height: 48px;
    width: 151px;
    left: 135px;
    top: 0px;
    border-radius: 0px;
    padding: 12px, 16px, 12px, 16px;
    border: 1px solid ${p => p.theme.webMktPalette.text.tertiaryLight};
    margin-right: 16px;
  }

  .active {
    background: ${p => p.theme.webMktPalette.blue[50]};
  }

  .active > p {
    color: ${p => p.theme.webMktPalette.text.primaryWhite};
  }

  ${p => p.theme.breakpoints.down('sm')} {
    display: none;
  }
`
export const DropDownContainer = styled.div`
  .selection__container {
    display: flex;
  }

  .selection__dropdown-container {
    width: 100%;
    height: 100%;
    position: relative;
    box-sizing: border-box;
    height: 48px;
    border: 1px solid rgba(0, 0, 0, 0.301961);
  }

  .selection__dropdown-item-container {
    position: absolute;
    width: 100%;
    display: none;
  }

  .Menu-item {
    background-color: ${p => p.theme.webMktPalette.background.white};
    padding-top: 12px;
    padding-bottom: 12px;
    p {
      margin: 0;
      line-height: 24px;
    }
  }

  .Menu-item.is-active:before {
    border-color: ${p => p.theme.webMktPalette.background.black};
  }

  .selected__menu-item {
    color: ${p => p.theme.webMktPalette.text.tertiaryLight};
    text-transform: capitalize;
  }

  ${p => p.theme.breakpoints.up('md')} {
    display: none;
  }

  .is-active {
    display: block;
    ${p => p.theme.breakpoints.down('sm')} {
      z-index: 4;
    }
  }

  ${p => p.theme.breakpoints.down('sm')} {
    flex: 1;
  }

  .selection__dropdown-item-container > .CTA {
    display: flex;
    border-left: 1px solid ${p => p.theme.webMktPalette.text.tertiaryLight};
    border-right: 1px solid ${p => p.theme.webMktPalette.text.tertiaryLight};
    border-top: 1px solid ${p => p.theme.webMktPalette.text.tertiaryLight};
  }

  .Dropdown__Tab__BTNS {
    height: 48px;
    border: 1px solid #0000004d;
    margin: 0 4px 8px 4px;
    padding: 12px 16px;
    ${p => p.theme.breakpoints.down('sm')} {
      margin: 0;
      height: 48px;
    }
  }

  a.Dropdown__Tab__BTNS:hover {
    background-color: ${p => p.theme.webMktPalette.blue[50]};
    color: ${p => p.theme.webMktPalette.text.primaryWhite};
  }
`
